export default __webpack_public_path__ + "static/media/Legend.71788dd5.png";